import { ReactElement } from "react";

export interface ServerError
  extends Record<string, string | Record<string, string> | undefined> {
  location?: string;
  name?: string;
  description: string;
  error_code?: string;
  transKey?: string;
  transValues?: Record<string, string>;
}

export interface ServerErrorResponse {
  status?: string;
  errors: ServerError[];
}

export interface CustomUIError {
  errorComponent: () => ReactElement;
}

export function isServerErrorResponse(err: any): err is ServerErrorResponse {
  return err && (err as ServerErrorResponse).errors !== undefined;
}

export function isServerError(err: any): err is ServerError {
  return err && (err as ServerError).description !== undefined;
}

export type TalaeraError =
  | ServerErrorResponse
  | ServerError
  | Array<ServerError>
  | ReactElement
  | string;

export function unknownErrorParser(err: ServerError) {
  if (isServerError(err)) {
    if (!err.description) {
      err.description = "Something went wrong.";
      err.transKey = "Common.somethingWrong";
    }
  }

  return err;
}
